<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          :class="active ? `v-btn--active` : ``"
          icon
          small
          :disabled="disabled"
          v-bind="attrs"
          v-on="on"
          @click="$emit('click', $event)"
      >
        <v-icon dark>
          mdi-{{ icon }}
        </v-icon>
      </v-btn>
    </template>
    <span>{{ name }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "BaseButton",
  props: {
    icon: String,
    name: String,
    active: Boolean,
    disabled: Boolean,
  }
}
</script>

<style scoped>

</style>


